import {
  spfOne,
  spfTwo,
  spfThree,
  spfFour,
  bestSellerOne,
  bestSellerTwo,
  bestSellerThree,
  bestSellerFour,
  newArrOne,
  newArrTwo,
  newArrThree,
  newArrFour,
} from "../assets/images/index";

// =================== NavBarList Start here ====================
export const navBarList = [
  {
    _id: 1001,
    title: "Home",
    link: "/",
  },
  {
    _id: 1002,
    title: "Frames",
    link: "/shop",
  },

  {
    _id: 1005,
    title: "Poster",
    link: "Poster",
  },
  {
    _id: 1003,
    title: "About",
    link: "/about",
  },
  {
    _id: 1004,
    title: "Contact",
    link: "contact",
  },
 
];
// =================== NavBarList End here ======================
// =================== Special Offer data Start here ============
export const SplOfferData = [
  {
    _id: "201",
    img: 'https://res.cloudinary.com/diisa3hxq/image/upload/v1753519288/spfTwo_nyg4kn.png',
    productName: "Messi Frame",
    price: "12999.00",
    color: "White",
    badge: true,
    des: "Lionel Messi wears Argentina’s iconic white shirt, representing greatness, legacy, and his unforgettable triumphs in world football history.",
  },
  {
    _id: "202",
    img: 'https://res.cloudinary.com/diisa3hxq/image/upload/v1753519835/bestSellerTwo_dmhxs3.png',
    productName: "CR7",
    price: "12999.00",
    color: "White",
    badge: true,
    des: "Cristiano Ronaldo's white team shirt symbolizes greatness, leadership, and excellence, representing his dominance and legendary status on the field.",
  },
  {
    _id: "203",
    img: 'https://res.cloudinary.com/diisa3hxq/image/upload/v1753519833/bestSellerThree_foxotg.png',
    productName: "CR7",
    price: "12999.00",
    color: "White & Yellow",
    badge: true,
    des: "Cristiano Ronaldo's white & Yellow team shirt symbolizes greatness, leadership, and excellence, representing his dominance and legendary status on the field.",
  },
  {
    _id: "204",
    img: 'https://res.cloudinary.com/diisa3hxq/image/upload/v1753531142/Untitled_design_15_yt2ggt.png',
    productName: "David Bechkam",
    price: "13999.00",
    color: "Black",
    badge: true,
    des: "David Becham black team shirt symbolizes greatness, leadership, and excellence, representing his dominance and legendary status on the field..",
  },
];
// =================== Special Offer data End here ==============

// =================== PaginationItems Start here ===============

export const paginationItems = [
  {
    _id: 1001,
    img: "https://res.cloudinary.com/diisa3hxq/image/upload/v1753519288/spfTwo_nyg4kn.png",
    productName: "Messi Frame",
    price: "7999.00",
    oldPrice: "12999.00",
    color: "White",
    badge: true,
    des: "Lionel Messi, the legendary Argentine footballer, is often seen wearing the light blue and white striped jersey of the Argentina national team.",
  },
  {
    _id: 1002,
    img: 'https://res.cloudinary.com/diisa3hxq/image/upload/v1753519286/spfThree_mqdsbv.png',
    productName: "Messi Frame",
    price: "7999.00",
    oldPrice: "12999.00",
    color: "Light Blue",
    badge: true,
    des: "Lionel Messi wears a light blue Caribbean shirt, radiating a relaxed yet stylish vibe, blending football excellence with tropical elegance.",
  },
  {
    _id: 1003,
    img: "https://res.cloudinary.com/diisa3hxq/image/upload/v1753519285/spfOne_wpwuwm.png",
    productName: "Messi Frame",
    price: "7999.00",
    oldPrice: "12999.00",
    color: "Dusty Pink",
    badge: true,
    des: "Lionel Messi wears a stylish dusty pink shirt, blending elegance and sportiness, making headlines with his iconic fashion choices.",
  },
  {
    _id: 1004,
    img: "https://res.cloudinary.com/diisa3hxq/image/upload/v1753519284/spfFour_w4ghut.png",
    productName: "Messi Frame",
    price: "7999.00",
    oldPrice: "13999.00",
    color: "Navy Blue",
    badge: true,
    des: "Lionel Messi dons a navy blue UNICEF shirt, showcasing his commitment to charity, leadership, and excellence both on and off the field.",
  },
  {
    _id: 1005,
    img: "https://res.cloudinary.com/diisa3hxq/image/upload/v1753520727/Mbappe_weohlx.webp",
    productName: "Mbappe",
    price: "7999.00",
    oldPrice: "12999.00",
    color: "White",
    badge: true,
    des: "Mbapppe wears a stylish white shirt, blending elegance and sportiness, making headlines with his iconic fashion choices.",
  },
  {
    _id: 1006,
    img: "https://res.cloudinary.com/diisa3hxq/image/upload/v1753520726/Mbappe_2_ekhqly.png",
    productName: "Mbappe",
    price: "7999.00",
    oldPrice: "12999.00",
    color: "Orange",
    badge: false,
    des: "Mbapppe wears a stylish Orange shirt, blending elegance and sportiness, making headlines with his iconic fashion choices.",
  },
  {
    _id: 1007,
    img: "https://res.cloudinary.com/diisa3hxq/image/upload/v1753531142/Untitled_design_15_yt2ggt.png",
    productName: "David Beckham",
    price: "7999.00",
    oldPrice: "13999.00",
    color: "Black",
    badge: true,
    des: "David Beckham wears a stylish Black shirt, blending elegance and sportiness, making headlines with his iconic fashion choices.",
  },
  {
    _id: 1008,
    img: "https://res.cloudinary.com/diisa3hxq/image/upload/v1753531239/BELLINGHAM.wep_ms1pfr.webp",
    productName: "Bellingham",
    price: "7999.00",
    oldPrice: "12999.00",
    color: "White & Blue",
    badge: false,
    des: " Bellingham wears a stylish Black shirt, blending elegance and sportiness, making headlines with his iconic fashion choices.",
  },
  {
    _id: 1009,
    img: "https://res.cloudinary.com/diisa3hxq/image/upload/v1753531337/Halland_lbhpys.webp",
    productName: "Haaland",
    price: "7999.00",
    oldPrice: "12999.00",
    color: "Sky Blue",
    badge: true,
    des: "Haaland wears a stylish Black shirt, blending elegance and sportiness, making headlines with his iconic fashion choices.",
  },
  {
    _id: 1010,
    img: 'https://res.cloudinary.com/diisa3hxq/image/upload/v1753519828/bestSellerFive_zdnifb.webp',
    productName: "CR7 Frame",
    price: "7999.00",
    oldPrice: "12999.00",
    color: "Dark Blue",
    badge: true,
    des: "Cristiano Ronaldo's Drak Blue team shirt symbolizes greatness, leadership, and excellence, representing his dominance and legendary status on the field.",
  },
  {
    _id: 1011,
    img: 'https://res.cloudinary.com/diisa3hxq/image/upload/v1753519835/bestSellerTwo_dmhxs3.png',
    productName: "CR7 Frame",
    price: "7999.00",
    oldPrice: "12999.00",
    color: "White",
    badge: true,
    des: "Cristiano Ronaldo's white team shirt symbolizes greatness, leadership, and excellence, representing his dominance and legendary status on the field.",
  },
  {
    _id: 1012,
    img: 'https://res.cloudinary.com/diisa3hxq/image/upload/v1753519833/bestSellerThree_foxotg.png',
    productName: "CR7 Frame",
    price: "7999.00",
    oldPrice: "12999.00",
    color: "White & Yellow",
    badge: false,
    des: "Cristiano Ronaldo's white & Yellow team shirt symbolizes greatness, leadership, and excellence, representing his dominance and legendary status on the field.",
  },
  {
    _id: 1013,
    img: 'https://res.cloudinary.com/diisa3hxq/image/upload/v1753519830/bestSellerFour_rjtwqk.png',
    productName: "CR7 Frame",
    price: "7999.00",
    oldPrice: "12999.00",
    color: "Red",
    badge: false,
    des: "Cristiano Ronaldo’s red shirt represents passion, power, and determination, embodying his fearless mentality and iconic presence on the football field.",
  },
  {
    _id: 1014,
    img: 'https://res.cloudinary.com/diisa3hxq/image/upload/v1753519831/bestSellerOne_zy5hrj.png',
    productName: "CR7 Frame",
    price: "7999.00",
    oldPrice: "12999.00",
    color: "Yellow",
    badge: true,
    des: "Cristiano Ronaldo wears Al Nassr’s yellow shirt, symbolizing pride, passion, and excellence in Saudi Arabian football history.",
  },
  {
    _id: 1015,
    img: "https://res.cloudinary.com/diisa3hxq/image/upload/v1753531456/Untitled_design_223_2_c1tkr3.webp",
    productName: "Rashford",
    price: "7999.00",
    oldPrice: "12999.00",
    color: "Red",
    badge: false,
    des: "Rashford iconic red shirt, representing greatness, legacy, and his unforgettable triumphs in world football history.",
  },
  {
    _id: 1016,
    img: "https://res.cloudinary.com/diisa3hxq/image/upload/v1753531520/M_Sala_FRAMES_mafbow.webp",
    productName: "M.Salah",
    price: "7999.00",
    oldPrice: "12999.00",
    color: "Red",
    badge: true,
    des: "M.Salah iconic red shirt, representing greatness, legacy, and his unforgettable triumphs in world football history.",
  },
  {
    _id: 1017,
    img: "https://res.cloudinary.com/diisa3hxq/image/upload/v1753531617/Lmain_Yamal_Frames_23_3_h76isx.webp",
    productName: "Lamin Yamal",
    price: "7999.00",
    oldPrice: "12999.00",
    color: "Red & Blue",
    badge: false,
    des: "Lamin Yamal iconic red shirt, representing greatness, legacy, and his unforgettable triumphs in world football history",
  },


  {
    _id: 1018,
    img:"https://res.cloudinary.com/diisa3hxq/image/upload/v1753531669/Untitled_design_23_3_vqpnkf.webp",
    productName: "Zidane",
     price: "7999.00",
    oldPrice: "12999.00",
    color: "White",
    badge: true,
    des: "Zidane iconic red shirt, representing greatness, legacy, and his unforgettable triumphs in world football history.",
  },
  {
    _id: 1019,
    img: "https://res.cloudinary.com/diisa3hxq/image/upload/v1753531824/Comming_soon_w86je6.png",
    productName: "",
    price: "00.00",
    color: "",
    badge: true,
    des: "",
  },
  {
    _id: 1020,
    img: "https://res.cloudinary.com/diisa3hxq/image/upload/v1753531824/Comming_soon_w86je6.png",
    productName: "",
    price: "00.00",
    color: "",
    badge: true,
    des: "",
  },
  {
    _id: 1021,
    img: "https://res.cloudinary.com/diisa3hxq/image/upload/v1753531824/Comming_soon_w86je6.png",
    productName: "",
    price: "00.00",
    color: "",
    badge: true,
    des: "",
  },
  {
    _id: 1022,
    img: "https://res.cloudinary.com/diisa3hxq/image/upload/v1753531824/Comming_soon_w86je6.png",
    productName: "",
    price: "00.00",
    color: "",
    badge: true,
    des: "",
  },
  {
    _id: 1023,
    img: "https://res.cloudinary.com/diisa3hxq/image/upload/v1753531824/Comming_soon_w86je6.png",
    productName: "",
    price: "00.00",
    color: "",
    badge: true,
    des: "",
  },
  {
    _id: 1024,
    img: "https://res.cloudinary.com/diisa3hxq/image/upload/v1753531824/Comming_soon_w86je6.png",
    productName: "",
    price: "00.00",
    color: "",
    badge: true,
    des: "",
  },
                                  // =================== Post.js Poster products starts from here =================

  {
    _id: 2001,
    img: "https://res.cloudinary.com/diisa3hxq/image/upload/v1753518551/Poster_1_tqyswt.png",
    productName: "Single Poster",
    price: "300.00",
    color: "4x6 & A4",
    badge: true,
    des: " Single Signed Poster, Available in standard A4 size (4x6). Each poster is personally signed, making it a unique collectible item or a perfect gift for fans and collectors",
  },
  {
    _id: 2002,
    img: "https://res.cloudinary.com/diisa3hxq/image/upload/v1753518553/Poster_2_znfysv.png",
    productName: "Poster Bundle 1",
    price: "750.00",
    color: "4: 4x6 posters",
    badge: true,
    des: "Get more for less with Bundle 1, featuring 4 individually signed posters in a compact 4x6 inch size. Perfect for decorating your space, gifting, or starting your own signed poster collection.",
  },
  {
    _id: 2003,
    img: "https://res.cloudinary.com/diisa3hxq/image/upload/v1753518554/Poster_3_cxhfas.png",
    productName: "Poster Bundle 2",
    price: "1500.00",
    color: "4: A4 posters",
    badge: true,
    des: "Elevate your collection with 4 signed A4 posters (8.3 x 11.7 inches). Perfect for collectors or as a unique gift, this bundle offers high-quality signed memorabilia at great value.",
  },
  {
    _id: 2004,
    img: "https://res.cloudinary.com/diisa3hxq/image/upload/v1753518556/Poster_4_uwpj8o.png",
    productName: "Poster Bundle 3",
    price: "3000.00",
    color: "4:A4 & 4:4x6",
    badge: true,
    des: "Get the best of both worlds with Bundle 3, including 4 A4 signed posters and 4 signed 4x6 posters. This bundle offers a variety of sizes for those who want to expand their collection with a mix of large and compact signed memorabilia.",
  },
  {
    _id: 2005,
    img: "https://res.cloudinary.com/diisa3hxq/image/upload/v1753518553/Poster_2_znfysv.png",
    productName: "Poster Bundle 4",
    price: "3000.00",
    color: "10: 4x6 posters",
    badge: true,
    des: "Expand your collection with Bundle 4, featuring 10 signed 4x6 posters. This bundle offers a variety of signed memorabilia at an incredible value, perfect for collectors, gifting, or decorating your space with unique, hand-signed pieces.",
  },
  {
    _id: 2006,
    img: "https://res.cloudinary.com/diisa3hxq/image/upload/v1753518551/Poster_1_tqyswt.png",
    productName: "Poster Bundle 5",
    price: "4500.00",
    color: "10:A4 posters",
    badge: true,
    des: "Take your collection to the next level with Bundle 5, featuring 10 signed A4 posters. Each 8.3 x 11.7 inch poster is hand-signed for authenticity, making this bundle a must-have for serious collectors or as an extraordinary gift.Poster ",
  },






                                        
 
];
// =================== PaginationItems End here =================
